
const authCredentials = {};

export function clearServiceCredentials() {
    authCredentials.authorization = null;
}

export function setServiceCredentials(username, password) {
    authCredentials.authorization = 'Basic ' + btoa(username + ':' + password);
}

/*
Takes object data and encodes all its enumerable properties
into a URL query string.
 */
function serializeQueryParams(data) {
    let str = [];
    for (let k in data) {
        str.push(encodeURIComponent(k) + "=" + encodeURIComponent(data[k]));
    }
    return str.join("&");
}

const defaultFetchInit = {
    method : 'GET',
    redirect : 'error',
    cache : 'no-cache',
    credentials: 'omit',
    headers : {}
};
export function doFetch(url, init, data) {
    init = Object.assign({}, defaultFetchInit, init);

    if (authCredentials.authorization) {
        init.headers['Authorization'] = authCredentials.authorization;
    }

    if (data) {
        if (init.method === 'GET') {
            url = url + '?' + serializeQueryParams(data);
        } else if (init.method === 'POST') {
            init.body = JSON.stringify(data);
            init.headers['content-type'] = 'application/json;charset=UTF-8';
        }
    }

    return fetch(url, init).then(
        (response) => {
            if (response.ok) {
                if (response.headers.get('content-type') === 'application/json') {
                    return response.json();
                }

                return response;
            } else {
                // FIXME: Fix reject reason
                return Promise.reject('Request failed');
            }
        }
    );
}




// WEBPACK FOOTER //
// ./src/service/service.js